import { takeLatest, call, put } from 'redux-saga/effects'

import externalCourseParticipantsList, {
  GetListResponse,
} from 'api/administration/externalCourseParticipants/GetList'
import {
  EXTERNAL_COURSE_PARTICIPANTS_ADMINISTRATION_GET_LIST,
  Actions,
  ExternalCourseParticipantsListPayload,
} from '../../actions/externalCourseParticipant.action'
import { ActionWithPayload } from '../../../helpers/redux-actions.helper'

const pattern = EXTERNAL_COURSE_PARTICIPANTS_ADMINISTRATION_GET_LIST

export type ExternalCourseParticipantsListAction = ActionWithPayload<
  typeof pattern,
  ExternalCourseParticipantsListPayload
>

function* externalCourseParticipantsListEffectSaga(
  action: ExternalCourseParticipantsListAction
) {
  try {
    const { params, externalCourseId } = action.payload
    const { page, usersFilter, searchText, sort, perPage, fastFilters } = params

    const { data, total, perPage: resPerPage }: GetListResponse = yield call(
      externalCourseParticipantsList,
      externalCourseId,
      {
        page,
        searchText,
        sort,
        perPage,
        fastFilters,
        usersFilter,
      }
    )
    yield put(
      Actions.setAdministrationListSuccess(data, total, resPerPage, sort)
    )
  } catch (error) {
    console.error('error: ', error)
    yield put(Actions.setLoading(false))
  }
}

export function* externalCourseParticipantsListWatcherSaga() {
  yield takeLatest(pattern, externalCourseParticipantsListEffectSaga)
}
